import script from "./TarefasFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./TarefasFormView.vue?vue&type=script&setup=true&lang=js"

import "./TarefasFormView.vue?vue&type=style&index=0&id=803c66f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-803c66f6"]])

export default __exports__